<template>
  <div style="display: flex; gap: 0.25rem">
    <template v-for="(item, index) in value">
      <v-chip
        v-if="index < maxRender"
        :key="index"
        v-text="item"
        small
        outlined
        color="primary"
        v-bind="$attrs"
      />
      <span v-if="index === maxRender" class="grey--text caption " :key="index">
        (+{{ value.length - maxRender }})
      </span>
    </template>
  </div>
</template>
<script>
export default {
  name: "SimpleGroupChip",
  props: {
    value: { type: Array, required: true, default: () => [] },
    maxRender: { type: Number, default: 2 }
  }
};
</script>
